import React, { useContext, useEffect, useState } from 'react';

import {
  Grid,
  Typography,
} from '@material-ui/core';

import {
  useHistory,
  useParams,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import BreadCrumb from '../../fields/breadCrumb';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawer from '../../fields/menuDrawer';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { getClinicianEnrolments, getEnrolmentSchedules, getAllSchedulingPatterns, modifyUserSchedule, getUserSchedules } from '../../../utils/comms';

import translations from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import { sectionTitle } from '../../../styles/formElementsStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';
import MySchedulesList from './mySchedulesList';

function ListMySchedulesClinician({ lang, handleChangeLang }) {
  const { idClinician } = useParams();
  const sessionContext = useContext(SessionContext);
  const [clinician, setClinician] = useState({});
  const [schedulesList, setSchedulesList] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const history = useHistory();
  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  const getCliniciansFromServer = async () => {
    setShowLoading(true);
    const clinicianInfo = await getUserSchedules(sessionContext.userToken);
    const mySchedules = [];
    if (clinicianInfo.status === 200) {
      setClinician(clinicianInfo.data.userSchedules);
      clinicianInfo.data.userSchedules.map((item) => mySchedules.push(item._id));
      const schedulingPatterns = await getAllSchedulingPatterns(sessionContext.userToken);
      if (schedulingPatterns.status === 200) {
        const enrolmentsFromServer = await getClinicianEnrolments(idClinician, sessionContext.userToken);
        if (enrolmentsFromServer.status === 200) { // Tenim llistat enrolments
          // per cada enrolment obtenir schedules
          const schedules = [];
          await Promise.all(enrolmentsFromServer.data.enrolments.map(
            async (enrolment) => {
              const schedulesFromServer = await getEnrolmentSchedules(enrolment._id, sessionContext.userToken);
              if (schedulesFromServer.status === 200) {
                schedulesFromServer.data.userSchedules.map((item) => {
                  let myScheduling = null;
                  if (item.schedulingPattern) {
                    myScheduling = schedulingPatterns.data.schedulingPatterns.filter((element) => element._id === item.schedulingPattern);
                  }
                  const isMine = mySchedules.includes(item._id);
                  if (isMine) {
                    schedules.push({
                      ...item,
                      clinicianFormsPlatforms: enrolment.program.clinicianFormsPlatform,
                      patientName: enrolment.patient.username,
                      programName: enrolment.program.sharedId,
                      programId: enrolment.program._id,
                      scheduleName: myScheduling !== null ? myScheduling[0].desc : item.name,
                    });
                  }
                });
              } else if (schedulesFromServer === 400) { // Error amb les dades
                console.log('Error 400 obtenint els getEnrolmentSchedules');
              } else { // Login KO. Altres errors
                console.log(schedulesFromServer);
              }
            },
          ));
          setSchedulesList(schedules);
        } else if (enrolmentsFromServer === 400) { // Error amb les dades
          console.log('Error 400 obtenint els pacients');
        } else { // Login KO. Altres errors
          console.log(enrolmentsFromServer);
        }
      } else if (schedulingPatterns === 400) { // Error amb les dades
        console.log('Error 400 obtenint els pacients');
      } else { // Login KO. Altres errors
        console.log(schedulingPatterns);
      }
    } else if (clinicianInfo === 400) { // Error amb les dades
      console.log('Error 400 obtenint els pacients');
    } else { // Login KO. Altres errors
      console.log(clinicianInfo);
    }
    setShowLoading(false);
  };

  useEffect(() => {
    getCliniciansFromServer();
  }, [sessionContext.userToken]);

  const gotoScreen = (screen) => {
    history.push(`/${sessionContext.role.toLowerCase()}/${screen}`);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  const changeUserSchedule = (out, idSchedule, token) => {
    (async () => {
      const putResponse = await modifyUserSchedule(out, idSchedule, token);
      if (putResponse.status === 200) {
        getCliniciansFromServer();
      }
      if (putResponse === 400) { // Error amb les dades
        console.log('Error 400 modificant UserSchedule');
      } else { // Login KO. Altres errors
        console.log(putResponse);
      }
    })();
  };

  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} handleShowDrawer={(show) => showMenuDrawer(show)} lang={lang} handleChangeLang={handleChangeLang}/>
      <MenuDrawer
        type={sessionContext.role.toLowerCase()}
        showDrawer={showDrawer}
        handleShowDrawer={(show) => showMenuDrawer(show)}
        handleGotoScreen={(screen) => gotoScreen(screen)}
      />
      <div className={classes.body}>
        <Grid container direction='column' spacing={2}>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            <BreadCrumb role={sessionContext.role.toLowerCase()} home={`mySchedulesInfoClinician/${idClinician}`} lang={lang} />
          </Grid>
          {/* ----------------------- Fila 1 ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>
                  {translations['_myForms']}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila 2 ----------------------- */}
          <Grid item>
            <Grid container justify='space-between' spacing={2}>
              <Grid item xs={12}>
                <MySchedulesList
                  schedulesData={schedulesList}
                  editScheduleData={changeUserSchedule}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(ListMySchedulesClinician);

ListMySchedulesClinician.propTypes = {
  lang: PropTypes.string.isRequired,
  handleChangeLang: PropTypes.func.isRequired,
};
